<template>
    <div class="">
        <header>
            <div class="container-fluid">
                <div class="pt-6">
                    <div class="row align-items-end">
                        <div class="col-sm col-12">
                            <h1 class="h2 ls-tight">Roles y permisos</h1>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <main class="py-6 bg-surface-secondary">
            <div class="container-fluid">
                <div class="vstack gap-6">
                    <div class="card">
                        <div class="card-header pb-0">
                            <div class="d-flex align-items-center">
                                <h5 class="me-auto">Administrar funciones</h5>
                            </div>
                            <p class="text-sm text-muted mt-1">Administre los roles de su cuenta y otorgue a sus
                                administradores solo los permisos necesarios.</p>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-3 col-6 mb-3" v-for="(item, index) in items" :key="index">
                                    <div class="card shadow-3-hover cursor-pointer">
                                        <div class="px-1 py-3">
                                            <div class="row justify-content-between align-items-center">
                                                <div class="col-lg-6 col-12">
                                                    <div class="d-flex align-items-center font-semibold">
                                                        <div>
                                                            <i :class="item.icon" class="text-lg me-3"></i>
                                                        </div>
                                                        <div class="ms-4">
                                                            <font style="vertical-align: inherit;">
                                                                <font style="vertical-align: inherit;">{{ item.description }}
                                                                </font>
                                                            </font>
                                                            <span class="d-block text-sm text-muted">{{
                                                                item.name
                                                            }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-auto col-12 mt-4 mt-lg-0">
                                                    <div
                                                        class="d-flex align-items-center justify-content-between gap-6">
                                                        <div>
                                                            <router-link
                                                                :to="{ name: 'RoleUpdate', params: { id: item.id } }">
                                                                <span
                                                                    class="cursor-pointer text-sm text-muted text-primary-hover font-semibold">
                                                                    <i class="bi bi-pencil-square me-2"></i>
                                                                </span>
                                                            </router-link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12" v-if="loading">
                                    <div class="text-center">
                                        <div class="spinner-border text-primary" role="status">
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
export default {
    data() {
        return {
            loading: true,
            id: null,
            items: []
        }
    },
    mounted() {
        this.INIT()
    },
    methods: {
        INIT: function () {
            let vue = this
            axios({ url: '/roles', method: 'GET' })
            .then((resp) => {
                vue.items = resp.data
            })
            .finally((resp) => {
                vue.loading = false
            })
        },
        DELETE: function (id) {
            let vue = this
            vue.id = id
            vue.ondelete = true
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/roles/Index.vue